export const entityOptions = [
  { _id: "All", role: "All" },
  { _id: "Binnys", role: "Binnys" },
  { _id: "Cariati", role: "Cariati" },
];

export const usersFilds =(roleData, id, createProjectRoleData, selectProjectRoleData) => {
  return [
    {
      title: "UserName",
      id: "username",
      name: "username",
      type: "text",
      placeholder: "Username",
    },
    {
      title: "First Name",
      id: "firstName",
      name: "firstName",
      type: "text",
      placeholder: "First Name",
    },
    {
      title: "Last Name",
      id: "lastName",
      name: "lastName",
      type: "text",
      placeholder: "Last Name",
    },
    {
      title: "Role",
      id: "role",
      name: "role",
      type: "select",
      placeholder: "Select Role",
      roleData: roleData,
    },
    // {
    //   title: "Binny’s Create Role",
    //   id: "createProjectRole",
    //   name: "createProjectRole",
    //   type: "select",
    //   placeholder: "Binny’s Create Role",
    //   roleData: createProjectRoleData,
    // },
    // {
    //   title: "Binny’s Select Role",
    //   id: "selectProjectRole",
    //   name: "selectProjectRole",
    //   type: "select",
    //   placeholder: "Binny’s Select Role",
    //   roleData: selectProjectRoleData,
    // },
    {
      title: id ? "New Password" : "Password",
      id: "password",
      name: "password",
      type: "text",
      placeholder: id ? "New Password" : "Password",
    },
    {
      title: "Confirm Password",
      id: "confirmPassword",
      name: "confirmPassword",
      type: "text",
      placeholder: "Confirm Password",
    },
    {
      title: "Email",
      id: "email",
      name: "email",
      type: "email",
      placeholder: "Email",
    },
    {
      title: "Entity",
      id: "entity",
      name: "entity",
      type: "select",
      placeholder: "Select Entity",
      roleData: entityOptions,
    },
  ];
};
